import React from 'react';
import { BarChartIndicatorSC } from './bar-segment-chart-indicator.styled';

const BarChartIndicator: React.FC<{
  indicatorConfig: { color: string; left: string };
}> = ({ indicatorConfig }) => {
  return (
    <BarChartIndicatorSC left={indicatorConfig.left} color={indicatorConfig.color}>
      <div className={'big'}>
        <div className={'small'} />
      </div>
    </BarChartIndicatorSC>
  );
};

export default BarChartIndicator;
